import React from "react";
import "./styles.scss";

interface CustomButtonProps {
  text: string;
  size?: "sm" | "md" | "lg";
}

const CustombuttonComponent = ({ text, size = "lg" }: CustomButtonProps) => {
  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return "py-2 px-6 rounded";
      case "md":
        return "py-3 px-9 rounded-lg";
      case "lg":
      default:
        return "py-4 px-12 rounded-full";
    }
  };

  return (
    <button
      className={`bg-sow-gold text-black border-none cursor-pointer font-bold ${getSizeClasses()}`}
    >
      {text}
    </button>
  );
};

export default CustombuttonComponent;
